import { render, staticRenderFns } from "./PedidoTable.vue?vue&type=template&id=2cca3b1f"
import script from "./PedidoTable.vue?vue&type=script&lang=js"
export * from "./PedidoTable.vue?vue&type=script&lang=js"
import style0 from "./PedidoTable.vue?vue&type=style&index=0&id=2cca3b1f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports